import { FirestoreWriteOp } from '@griply/services';
import { SharedCollection } from '@griply/types';
import { doc } from 'firebase/firestore';
import { ID } from 'shared/types/id';
import { RoleOption, Roles } from 'shared/types/roles';

import { getAuthentication } from './auth';
import { getCollection } from './get-collection';
import { setDocWithTimestamp } from './set-doc-with-timestamp';

type ReturnType<T> = T & { id: ID; roles: Roles };

export const addDocumentWithOwnerRole = async <T extends {}>(
  collection: SharedCollection,
  data: T,
  op: FirestoreWriteOp,
): Promise<ReturnType<T>> => {
  // Get the currently authenticated user
  const user = (await getAuthentication()).currentUser;

  if (!user) {
    throw Error('unauthenticated');
  }

  // Create a new reference to the Firestore collection
  const newDoc = doc(getCollection(collection));

  const newDocData = {
    ...data,
    id: newDoc.id,
    roles: { [RoleOption.Owner]: user.uid, [RoleOption.All]: [user.uid] },
  } as ReturnType<T>;

  setDocWithTimestamp(newDoc, newDocData, op);

  return newDocData;
};
